/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { InvestmentStatusValues } from '../types/utils';
import { UserID } from './user-model';

export class GetInvestmentInput {
	status?: InvestmentStatusValues

	userId?: UserID
}